import React, { FC, ReactNode, useRef } from 'react';
import { Popup, PopupHeader } from '@shared/uikit/popup';
import { GrayButton } from '@shared/uikit/button';

interface IProps {
  width: string;
  isSubmitting: boolean;
  onClose: () => void;
  onClear: () => void;
  onSubmit: () => void;
  children: ReactNode | ReactNode[];
}

const HostingCreatePopup: FC<IProps> = ({
  width,
  isSubmitting,
  onClose,
  onClear,
  onSubmit,
  children,
}) => {
  const submitRef = useRef<HTMLInputElement>(null);

  return (
    <Popup open={true} onClose={onClose} width={width}>
      <form onSubmit={onSubmit} className=" max-h-[500px] overflow-y-scroll overflow-x-hidden">
        {children}
        <input type="submit" disabled={isSubmitting} ref={submitRef} style={{ display: 'none' }} />
      </form>
      <div className="text-left flex items-center justify-between pt-[15px]">
        <span className="cursor-pointer text-[10px]" onClick={() => onClear()}>
          Сбросить данные
        </span>
        <div className="text-[white] flex gap-[10px]">
          <GrayButton
            type="submit"
            onClick={() => submitRef?.current?.click()}
            title="Создать хостинг"
          />
        </div>
      </div>
    </Popup>
  );
};

export default HostingCreatePopup;
